module.exports = __webpack_public_path__ + "static/medal-miwc-gold2020b-f2bff99c27f865992da165dbd5203876.png";